
import CollectionReporterTable from './components/collectionReporterTable.vue'
import AddReporterToCollection from './components/addReporterToCollection.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IReporterCollection, ICollectionReporter } from '@/types/reporter-types'
import { ReporterService } from '@/services/index'
import reporterService from '@/services/reporter-service'

enum DialogStatus {
    ADD = 'add',
    EDIT = 'edit'
}

@Component({
    components: {
        CollectionReporterTable,
        AddReporterToCollection
    }
})
export default class extends Vue {

    @Prop({ type: Boolean, default: false }) AsComponent!: boolean
    @Prop({ type: String, default: '' }) title!: string
    // @Prop({ type: String, default: '' }) type: string

    private editIndex!: number
    private collectionId: number = 0
    private collection: IReporterCollection = { name: '', cover_img: '', memo: '' }
    private collectionReporters: Array<ICollectionReporter> = []
    private loading: any = ''
    private editRow: ICollectionReporter | null = null
    private addPopover: boolean = false
    private dialogStatus: string = DialogStatus.ADD
    private pageSize: number = 10
    private pageIndex: number = 1
    private total: number = 0
    private _parent: any

    private created() {
        const { id } = this.$route.params
        this.collectionId = Number(id)
    }

    private mounted() {
        if (this.AsComponent) {
            this._parent = this.$parent
            this.collectionId = this._parent.recommendId
            this.getCollectionReporters()
            return
        }
        Promise.all([
            this.getCollectionDetail(), 
            this.getCollectionReporters()
        ])
    }

    // 获取记者集合详情
    private async getCollectionDetail() {
        const params = {
            id: this.collectionId
        }
        const result = await ReporterService.getReporterCollectionDetail(params)
        this.closeLoading()
        if (result.status === 200) {
            this.collection = result.data
            return
        }
        this.$message({ message: result.message, showClose: true })
    }

    // 获取集合下的记者
    private async getCollectionReporters() {
        const params = {
            id: this.collectionId,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await ReporterService.getReportersFromCollection(params)
        this.closeLoading()
        if (result.status === 200) {
            this.total = result.data.page_total
            this.collectionReporters = result.data.results
            return
        }
        this.$message({ message: result.message, showClose: true })
    }

    // 添加记者按钮
    private addReporter(): void {
        this.dialogStatus = DialogStatus.ADD
        this.addPopover = true
    }

    // 提交回调
    private handleSubmit(item: ICollectionReporter) {
        // 显示 loading
        this.loading = this.$loading({
            lock: true,
            target: '.reporter-collection',
            text: this.dialogStatus === DialogStatus.ADD ? '添加记者中' : '修改记者中'
        })
        // 处理请求
        if (this.dialogStatus === DialogStatus.ADD) {
            // 新增记者
            this.addReporterToCollection(item)
        } else {
            // 修改记者
            this.updateReporterAtCollection(item)
        }
    }

    // 增加记者请求
    private async addReporterToCollection(item: ICollectionReporter) {
        const params = {
            set_id: this.collectionId,
            reporter_id: item.id,
            order: item.order as number,
            note: item.note ? item.note : undefined
        }
        const result = await reporterService.addReporterToCollection(params)
        if (result.status === 200) {
            this.$message({ showClose: true, message: '添加记者成功', type: 'success' })
            return this.getCollectionReporters()
        }
        this.closeLoading()
    }

    private async updateReporterAtCollection(item: ICollectionReporter) {
        const params = {
            set_id: this.collectionId,
            reporter_id: item.id,
            order: item.order as number,
            note: item.note ? item.note : undefined
        }
        const result = await reporterService.updateReporterAtCollection(params)
        if (result.status === 200) {
            this.$message({ showClose: true, message: '修改记者成功', type: 'success' })
            return this.getCollectionReporters()
        }
        this.closeLoading()
    }
    
    // 编辑记者
    private handleEdit(index: number) {
        this.dialogStatus = DialogStatus.EDIT
        this.editIndex = index
        const item = JSON.stringify(this.collectionReporters[index])
        this.editRow = JSON.parse(item)
        this.addPopover = true
    }

    // 删除记者
    private handleRemove(id: number) {
        this.$confirm('你是否确定从这个系列中去掉这个记者?', '确定', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            // 删除之后重新获取一次数据
            const params = {
                set_id: this.collectionId,
                reporter_id: id
            }
            const result = await ReporterService.deleteReporterAtCollection(params)
            if (result.status === 200) {
                this.$message({ type: 'success', message: '删除成功!' })
                // 计算当前页面
                const length = this.collectionReporters.length
                this.pageIndex = length - 1 > 0 ? this.pageIndex : this.pageIndex - 1 
                return this.getCollectionReporters()
            }
            this.$message({ type: 'error', message: result.message })
        })
    }

    private closeLoading() {
        this.loading && this.loading.close()
    }

    // 当前页数改变
    private onCurrentPageChange(currPage: number) {
        this.pageIndex = currPage
        this.getCollectionReporters()
    }
}
